import { Loader2, TriangleAlert, XCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { fetchAllServices, fetchPackages } from "../../services/apiService";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";

function UpdateQuotationModal({
  data,
  isOpen,
  onClose,
  editTempReport,
  index,
  client,
  oneTimeFee,
  allWallets,
  oldService,
}) {
  const [billingType, setBillingType] = useState("1");
  const [service, setService] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [ots, setOts] = useState("");
  const [wallets, setWallets] = useState([""]);
  const [selectedService, setSelectedService] = useState({});
  const [allPackages, setAllPackages] = useState([]);
  const [packageLoading, setPackageLoading] = useState(false);
  const [serviceLoading, setServiceLoading] = useState(false);
  // State for generated report
  const [report, setReport] = useState([]);
  const [page, setPage] = useState(0);
  const [quotationLoading, setQuotationLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [clientName, setClientName] = useState("");

  const handlePackageChange = (e, bType) => {
    const values = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    if (bType === "2") {
      setSelectedPackages([values[0], values[1]]);
    } else if (bType === "3") {
      setSelectedPackages([values[0], values[1], values[2]]);
    } else {
      setSelectedPackages([values[0]]);
    }
  };

  const handleRemovePackage = (index) => {
    setSelectedPackages(selectedPackages.filter((_, idx) => idx !== index));
  };

  const handleWalletChange = (index, value) => {
    const newWallets = [...wallets];
    newWallets[index] = value;
    setWallets(newWallets);
  };

  // const getAllServices = async () => {
  //   setServiceLoading(true);
  //   try {
  //     const res = await fetchAllServices({ page: page + 1 });

  //     if (res.status?.code === 200) {
  //       const { data, pagination } = res;
  //       setService((prev) => [...prev, ...res.data]);
  //       setPage((prev) => prev + 1);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setServiceLoading(false);
  //   }
  // };

  const searchServices = async () => {
    setServiceLoading(true);
    try {
      const res = await fetchAllServices({ search: debouncedSearch });

      if (res.status?.code === 200) {
        setService(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setServiceLoading(false);
    }
  };

  const getPackages = async () => {
    setPackageLoading(true);
    try {
      const res = await fetchPackages({ service_id: selectedService?.id });

      if (res.status?.code === 200) {
        setAllPackages(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPackageLoading(false);
    }
  };

  const handleGeneration = async () => {
    if (!selectedService?.id) {
      return showErrorToast("please select service");
    } else if (!clientName) {
      return showErrorToast("Please Enter Name");
    } else if (!selectedPackages.length > 0) {
      return showErrorToast("please select package");
    } else if (billingType === "1" && !ots && wallets[0] === "") {
      return showErrorToast("please enter topup amount or one time fee");
    } else if (
      billingType === "2" &&
      !ots &&
      (wallets[0] === "" || wallets[1] === "")
    ) {
      return showErrorToast("please enter two topup amount or one time fee");
    } else if (
      billingType === "3" &&
      !ots &&
      (wallets[0] === "" || wallets[1] === "" || wallets[2] === "")
    ) {
      return showErrorToast("please enter three topup amount or one time fee");
    } else if (
      billingType === "2" &&
      (selectedPackages.includes(null) ||
        selectedPackages.includes(undefined) ||
        selectedPackages.includes(""))
    ) {
      return showErrorToast("please select two packages");
    } else if (
      billingType === "3" &&
      (selectedPackages.includes(null) ||
        selectedPackages.includes(undefined) ||
        selectedPackages.includes(""))
    ) {
      return showErrorToast("please select three packages");
    }

    // setQuotationLoading(true);

    const tempData = {
      service_id: selectedService?.id,
      service_name: selectedService?.service_name,
      category: selectedService?.service_category?.name,
      billing_type: billingType,
      packages: selectedPackages,
      wallets: wallets,
      system_prices: selectedPackages?.map(
        (mainitem) =>
          allPackages?.find((item) => item?.package_id == mainitem)?.charge
            ?.amount,
      ),
    };

    const finalData = {
      tempData: tempData,
      newClient: clientName,
      newOts: ots,
      newWallets: wallets,
    };

    editTempReport(finalData, index);

    showSuccessToast("Updated Successfully");

    onClose();
  };

  // useEffect(() => {
  //   getAllServices();
  // }, []);

  useEffect(() => {
    if (!selectedService?.id) return;

    getPackages();
  }, [selectedService?.id]);

  useEffect(() => {
    let count = 1;
    if (billingType === "2") count = 2;
    if (billingType === "3") count = 3;

    setWallets(new Array(count).fill(""));
    // setSelectedPackages([]); 
  }, [billingType]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [searchInput]);

  useEffect(() => {
    searchServices();
  }, [debouncedSearch]);

  useEffect(() => {
    if (!data || index < 0) return;
    const editableData = data[index];
    console.log("editable data", editableData);
    setClientName(client);
    setBillingType(editableData?.billing_type);
    setWallets(editableData?.wallets);
    setOts(oneTimeFee);
    setSelectedPackages(editableData?.packages);
    setSelectedService(oldService);
    setSearchInput(editableData?.service_name);
  }, [data, index, oldService]);

  useEffect(() => {
    console.log("selected packages", selectedPackages);
  }, [selectedPackages]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      />

      {/* Modal */}
      <div className="relative px-2 md:px-6 w-[95%] max-w-3xl max-h-[90vh] bg-white rounded-2xl shadow-2xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-6 py-4">
          <h2 className="text-xl font-semibold text-[#23C362]">
            Update Quotation Details
          </h2>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-500 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto px-6 py-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Client Name */}
            <div className="flex flex-col gap-2">
              <label className="text-xs font-bold uppercase text-slate-500">
                1. Client Name
              </label>
              <input
                type="text"
                value={clientName}
                placeholder="Eg. IDSPay"
                onChange={(e) => setClientName(e.target.value)}
                className="w-full py-2 px-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Billing Type */}
            <div className="flex flex-col gap-2">
              <label className="text-xs font-bold uppercase text-slate-500">
                2. Billing Type
              </label>
              <select
                value={billingType}
                onChange={(e) => setBillingType(e.target.value)}
                className="w-full p-2 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              >
                <option value="1">Single Plan</option>
                <option value="2">Two Plan</option>
                <option value="3">Three Plan</option>
              </select>
            </div>

            {/* Search Service (full width) */}
            <div className="flex flex-col gap-2">
              <label className="text-xs font-bold uppercase flex justify-between text-slate-500">
                3. Search API Service
                <Loader2
                  size={18}
                  className={`text-green-600 animate-spin ${serviceLoading ? "opacity-100" : "opacity-0"}`}
                />
              </label>

              <input
                type="search"
                value={searchInput}
                placeholder="Search Here..."
                onChange={(e) => setSearchInput(e.target.value)}
                className="w-full py-2 px-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />

              {service?.length > 0 ? (
                <div className="border rounded-lg bg-slate-50 max-h-48 overflow-y-auto">
                  {service.map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => setSelectedService(item)}
                      className={`px-3 py-2 cursor-pointer ${
                        selectedService?.id === item?.id
                          ? "bg-blue-600 text-white"
                          : "hover:bg-slate-200"
                      }`}
                    >
                      {item?.service_name}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-red-500 text-sm flex items-center gap-2">
                  <TriangleAlert size={16} />
                  {searchInput} Not Found
                </div>
              )}
            </div>

            {/* Packages */}
            <div className=" flex flex-col gap-2">
              <label className="text-xs font-bold uppercase text-slate-500">
                4. Select Package(s)
              </label>

              <select
                multiple={billingType !== "1"}
                value={selectedPackages}
                onChange={(e) => handlePackageChange(e, billingType)}
                className="w-full p-2 bg-slate-50 border border-slate-300 rounded-lg"
              >
                <option disabled value="">
                  Select Package
                </option>
                {allPackages?.map((item, idx) => (
                  <option key={idx} value={item.package_id}>
                    {item.package_name}
                  </option>
                ))}
              </select>

              <p className="text-xs text-slate-400">
                {billingType === "1"
                  ? "Select one package."
                  : "Hold Ctrl/Cmd to select multiple."}
              </p>

              {/* Selected chips */}
              {selectedPackages?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {selectedPackages?.map((item, idx) => {
                    const pkg = allPackages.find((ap) => ap.package_id == item);
                    if (!pkg) return null;

                    return (
                      <button
                        key={idx}
                        onClick={() => handleRemovePackage(idx)}
                        className="flex items-center gap-2 px-3 py-1 text-xs rounded-full bg-green-100 border border-green-700 text-green-700 hover:bg-rose-100 hover:text-rose-700 hover:border-rose-700"
                      >
                        {pkg.package_name} ₹{pkg?.charge?.amount}
                        <XCircle size={14} />
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            {/* OTS */}
            <div className="flex flex-col gap-2">
              <label className="text-xs font-bold uppercase text-slate-500">
                5. OTS Fee
              </label>
              <div className="relative">
                <span className="absolute left-3 top-2 text-slate-400">₹</span>
                <input
                  type="number"
                  value={ots}
                  onChange={(e) => setOts(e.target.value)}
                  className="w-full pl-8 py-2 bg-slate-50 border border-slate-300 rounded-lg"
                />
              </div>
            </div>

            {/* Wallets */}
            <div className="flex flex-col gap-2">
              <label className="text-xs font-bold uppercase text-slate-500">
                6. Wallet Topup
              </label>

              <div className="space-y-2">
                {wallets?.map((wallet, idx) => (
                  <div key={idx} className="relative">
                    <span className="absolute left-3 top-2 text-xs text-slate-400">
                      Plan {idx + 1}
                    </span>
                    <input
                      type="number"
                      value={wallet}
                      onChange={(e) => handleWalletChange(idx, e.target.value)}
                      className="w-full pl-16 py-2 border rounded-lg"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="mt-6">
            <button
              onClick={handleGeneration}
              className="w-full bg-[#23C362] hover:bg-[#119445] text-white font-semibold py-3 rounded-xl"
            >
              {quotationLoading ? (
                <Loader2 className="animate-spin mx-auto" />
              ) : (
                "Update Quotation"
              )}
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t px-6 py-3 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateQuotationModal;
